export type CaseStudyLayout = 'wide' | 'phones' | 'bleed';

export type CaseStudy = {
  id: string;
  client: string;
  title: string;
  href: string;
  background: string;
  layout: CaseStudyLayout;
  images: string[];
  /** Optional looping videos keyed by image index; the image at that index is used as the poster. */
  videos?: Record<number, string>;
};

export const caseStudies: CaseStudy[] = [
  {
    id: 'rsi',
    client: 'RSI',
    title: 'Modernizing platform architecture to improve profitability by 46%',
    href: '/case-studies/rsi',
    background: 'linear-gradient(180deg, #F4E6E4 0%, #D7C5C1 100%)',
    layout: 'wide',
    images: ['https://cdn.magicpatterns.com/uploads/kcwDUk7jMCCfFL2giukhQM/Unified-Inbox-Reporting-AI-Magic-Patterns-09-25-2026_06_22_PM.jpg'],
    videos: {
      0: 'https://cdn.magicpatterns.com/uploads/74vu4nyQytFCkV2QUzZPJ3/RSIvideo.mp4',
    },
  },
  {
    id: 'hotelplanner',
    client: 'HotelPlanner',
    title: 'Redesigning an online booking experience with $1B annual volume',
    href: '/case-studies/hotelplanner',
    background: 'linear-gradient(180deg, #E8F0F6 0%, #B8CCDC 100%)',
    layout: 'phones',
    images: [
      'https://cdn.magicpatterns.com/uploads/i6tAHxsgRRbw5V411qPSMN/hotel_detail_mobile.png',
      'https://cdn.magicpatterns.com/uploads/irknuxTCxeA3rRs8QGGTLT/Screenshot.png',
      'https://cdn.magicpatterns.com/uploads/iawm8sT3chDM9pZr6cWA22/results_mobile.png',
    ],
    videos: {
      0: 'https://cdn.magicpatterns.com/uploads/qk2m2KJH1GcwVeEQWJ2fdz/hp%20hotel%20page%20mobile.mp4',
    },
  },
  {
    id: 'amex',
    client: 'American Express',
    title: 'Cutting enterprise card origination from 22 to 18 days',
    href: '/case-studies/amex',
    background: 'linear-gradient(180deg, #DAF0FC 0%, #A3BECD 100%)',
    layout: 'bleed',
    images: ['https://cdn.magicpatterns.com/uploads/2Q5Z5Eq8UndCPBPXnCpfkH/Magic-Patterns-09-25-2026_06_12_PM.jpg'],
    videos: {
      0: 'https://cdn.magicpatterns.com/uploads/o9iKzFyVWiXdUWuGMAvJkz/AmexVideo.mp4',
    },
  },
  {
    id: 'mckinsey',
    client: 'McKinsey',
    title: 'Designing the pitch that won a $10M data transformation',
    href: '/case-studies/mckinsey',
    background: 'linear-gradient(180deg, #E9F3F5 0%, #B7CED3 100%)',
    layout: 'wide',
    images: ['https://cdn.magicpatterns.com/uploads/8rnthPdb7JvhCRiVREdFxR/Magic-Patterns-09-25-2026_06_29_PM.jpg'],
    videos: {
      0: 'https://cdn.magicpatterns.com/uploads/kxYBVsfU2cdWVmac4dBC6Y/AonVideo.mp4',
    },
  },
];

export const heroMetrics = [
  // "\n" marks where each caption breaks onto its second line.
  { value: '46%', label: 'increase in\nprofit margin' },
  { value: '18%', label: 'reduction in\nsales cycle time' },
  { value: '$10M+', label: 'contract\nunlocked' },
];
